<template>
  <el-tabs type="border-card" v-model="activeName">
    <el-tab-pane label="订单统计" name="1">
      <div class="el-icon-warning-outline">条件查询</div>
      <div class="condition-css">
        <el-form ref="form" :model="form" >
          <span>查询日期：</span>
          <el-date-picker
            v-model="form.startDateStr"
            value-format="yyyy-MM-dd"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="jobSearch"
            :picker-options="pickerOptions">
          </el-date-picker>
          <span style="margin-left:60px">显示条件：</span>
          <el-select v-model="form.groupCt" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button type="primary" size="mini" icon="el-icon-search" style="margin-left: 20px" @click="querySubmit">搜索</el-button>
        </el-form>
      </div>
      <div class="el-icon-warning-outline">订单统计 <span style="color:red;">(上线付款和线下付款合并)</span></div>
      <div class="box-css">
        <div class="box-other box-lite">
          有效金额：{{orderDetail.effectiveAmount}}
        </div>
        <div class="box-other box-lite">
          退款金额：{{orderDetail.refundAmount}}
        </div>
        <div class="box-other box-lite">
          总订单量：{{orderDetail.orderCount}}
        </div>
        <div class="box-other box-lite">
          商品数量：{{orderDetail.goodsCount}}
        </div>
      </div>
      <div class="el-icon-warning-outline">订单金额 <span style="color:red;">(上线付款和线下付款合并)</span></div>
      <div class="condition-css">
        <div id="myUserChart" :style="{width: '115%', height: '400px', margin: '0px 0 0 -100px'}"></div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { required, minLength } from "vuelidate/lib/validators";
import { formatDate } from "../../../js/common/date.js";
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')

export default {
  data() {
    return {
      data: [],
      saleTimeList: [],
      saleAmountList: [],
      activeName: "1",
      showKey: true,
      options: [{
        value: 1,
        label: '按天'
      }, {
        value: 2,
        label: '按月'
      }],
      orderDetail: {
        effectiveAmount: 0,
        refundAmount:0,
        orderCount: 0,
        goodsCount: 0
      },
      form: {
        token: this.user.getToken(),
        startDateStr: [],
        groupCt: 1
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dataDefualt: [
      ],
      error: ""
    };
  },
  methods: {
    querySubmit: function() {
      this.getOrderData()
    },
    getOrderData: function() {
      this.http.post(
        '/home/order/amount', 
        this.form, res => {
          if (res.success) {
            let userCountList = res.datas.data.userCountList
            this.orderDetail.effectiveAmount = res.datas.data.effectiveAmount
            this.orderDetail.refundAmount = res.datas.data.refundAmount
            this.orderDetail.orderCount = res.datas.data.orderCount
            this.orderDetail.goodsCount = res.datas.data.goodsCount
            var dateList = userCountList.map(function (item) {
                return item[0].replace('2021', 2025);
            });
            var valueList = userCountList.map(function (item) {
                return item[1];
            });
            // 引入基本模板
            let echarts = require('echarts/lib/echarts')
            let myUserChart = echarts.init(document.getElementById('myUserChart'))
            // 绘制图表
            myUserChart.setOption({
              visualMap: [
                {
                  show: false,
                  type: 'continuous',
                  seriesIndex: 0,
                  min: 0,
                  max: 100000
                },
              ],
              title: { left: 'center',text: '订单金额数据' },
              tooltip: {
                  left: 'center',
                  trigger: 'axis'
              },
              xAxis: {
                  data: dateList,
              },
              yAxis: {
              },
              grid: {
                  bottom: '25%'
              },
              series: {
                type: 'line',
                showSymbol: false,
                data: valueList,
              }
            });
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    difference: function (beginTime, endTime) {
      var dateBegin = new Date(beginTime);
      var dateEnd = new Date(endTime);
      var dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
      var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
      return dayDiff
    },
    jobSearch: function() {
      if (this.difference(this.form.startDateStr[0], this.form.startDateStr[1]) < 31) {
        this.form.groupCt = 1
      }
    },
    getCurrentMonthFirst () {
      var date = new Date()
      date.setDate(1)
      var month = parseInt(date.getMonth() + 1)
      var day = date.getDate()
      if (month < 10)  month = '0' + month
      if (day < 10)  day = '0' + day
      return date.getFullYear() + '-' + month + '-' + day
    },
  },
  mounted: function() {
    console.log("初始化..........")
    const end= new Date()
    const start = new Date(this.getCurrentMonthFirst ())
    this.form.startDateStr = [start, end]
    this.getOrderData()
  }
};
</script>


<style>
.condition-css {
  margin-top: 6px;
  padding: 20px;
  border: 1px solid #eee;
  margin-bottom: 20px;
}
.report-css {
  border: 1px solid #eee;
}
.box-css {
  margin-top: 6px;
  display: flex;
  padding: 15px 20px;
  border: 1px solid #eee;
  margin-bottom: 20px;
}
.box-other {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 14%;
  margin: 0 30px 0 40px;
  border-radius: 4px 4px 4px 4px!important;
  padding: 10px 20px;
  background: #F2F6FC;
}
.box-lite {
  color: #9a9a9a;
}
</style>


// WEBPACK FOOTER //
// src/components/views/home/reportOrder.vue